import { Component, Vue } from 'vue-property-decorator';
import { IRouteParsed, IRouteData } from './types';
import { routeParse, routeParseType } from '../utils';

@Component
export default class RouteParsedMixin extends Vue implements IRouteParsed {
  parse({ id, code }: IRouteData): routeParseType {
    return routeParse(id, code);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/RouteParseMixin.ts